// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__30Ytu","topBottomGutter":"Layout_topBottomGutter__1xaz2"};